// extracted by css-extract-rspack-plugin
export default {"cls1":"FriendlySutdModal-cls1_p69","cls2":"FriendlySutdModal-cls2_dxH FriendlySutdModal-cls1_p69"};